module.exports = __webpack_public_path__ + "img/dropsSlots_1248.02690cc2.png";